import moment from 'moment';
import { useQuery } from '@apollo/client';

import { FetchDirections, FetchMainAirports } from '../queries/index.graphql';
import { DEFAULT_CHECKIN_TIME } from '../constants';

export const createOptions = (min, max, units = '') => {
  const options = [];
  for (let i = min; i <= max; i++) {
    const option = {
      id: i.toString(),
      name: `${i}${units}`,
      value: i,
    };
    options.push(option);
  }
  return options;
};

export const getNameFromOptions = (id, options) => {
  return getPropValueFromOptions(id, options);
};

export const getPropValueFromOptions = (selectedId, options, propName = 'name') => {
  if (!(options && options.length)) {
    return '';
  }

  const selected = options.find(({ id })=> id === selectedId);

  if (!selected) {
    return '';
  }

  return selected[propName];
};

export const convertEnumValuesToOptions = (enumValues, withUnselected = false) => {
  if (!enumValues) {
    return [];
  }

  const options = enumValues.map((item) => ({
    id: item.name,
    name: item.description,
    value: item.name,
  }));

  return withUnselected ? addUnselectedOption(options) : options;
};

export const addUnselectedOption = (array, unselectedLabel) => {
  const unselectedOption = {
    id: undefined,
    name: unselectedLabel || undefined,
    value: undefined,
  };

  return array ? [unselectedOption, ...array] : [unselectedOption];
};

export const createCheckinOptions = (start, close) => {
  const startTime = moment(start || DEFAULT_CHECKIN_TIME, 'HH:mm');
  let closeTime = moment(close || DEFAULT_CHECKIN_TIME, 'HH:mm');
  if (!closeTime.isValid()) {
    const closeHour = Number(close.substr(0, 2));
    closeTime = moment('00:00', 'HH:mm').add(closeHour, 'hours');
  }

  const duration = 30; // minutes

  const optionNumber = closeTime.diff(startTime, 'minutes') / duration;
  const options = [];
  for (let i = 0; i <= optionNumber; i++) {
    let time = startTime.clone().add(i * duration, 'minutes').format('HH:mm');

    let hour = Number(time.substr(0, 2));
    // 10時前の時間は次の日とみなして24時間足す
    if (hour < 10) {
      hour += 24;
      const minute = time.substr(3, 2);
      time = `${hour.toString()}:${minute}`;
    }

    const option = {
      id: time,
      name: time,
      value: time,
    };
    options.push(option);
  }
  return options;
};

export const filterAvailableFlights = (flights) => (
  flights.filter((f) => f.seatStatus === 'Vacant')
);

export const createQuestionOptions = (selections, withUnselected = false) => {
  if (!(selections && selections.length)) {
    return [];
  }

  const options = selections.map((selection) => ({
    id: selection.text,
    name: selection.text,
    value: selection.text,
  }));

  return withUnselected ? addUnselectedOption(options) : options;
};

export const useDirections = () => {
  const { data } = useQuery(FetchDirections);
  const { data: mainAirportsData } = useQuery(FetchMainAirports);

  const directions = data ? data.directions.map((direction) => {
    const { id, name, airports } = direction;
    const group = {
      id,
      name,
      options: airports,
    };
    return group;
  }, []) : [];
  const mainAirports = mainAirportsData ? mainAirportsData.mainAirports : [];

  const directionsWithMainAirports = [
    { id: '_', name: '主要空港', options: mainAirports },
    ...directions,
  ];

  return directionsWithMainAirports;
};
